// extracted by mini-css-extract-plugin
export default {"PostMenuTrigger":"ph_a bhi_i bhi_j bhi_q bhi_vr bhi_xj bhi_er"};